var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
/**
* Data source to provide what data should be rendered in the table. The observable provided
* in connect should emit exactly the data that should be rendered by the table. If the data is
* altered, the observable should emit that new set of data on the stream. In our case here,
* we return a stream that contains only one set of data that doesn't change.
*/
var TableDataSource = (function (_super) {
    __extends(TableDataSource, _super);
    function TableDataSource(subject, _paginator, _sort, _httpClient) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this._paginator = _paginator;
        _this._sort = _sort;
        _this.curPage = 2; //required to change pagination dynamically
        _this.initialPageSize = 5; //required to pass on pagination grid
        _this.pageSizeOptions = [5, 10, 25, 50, 100];
        _this._httpClient = _httpClient;
        return _this;
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    TableDataSource.prototype.connect = function () {
        var _this = this;
        var displayDataChanges;
        // If pagination has been defined
        if (this._paginator) {
            displayDataChanges = [
                this.subject,
                this._paginator.page,
                this._sort.mdSortChange
            ];
        }
        else {
            // If pagination is not defined then don't paas pagination object
            displayDataChanges = [
                this.subject,
                this._sort.mdSortChange
            ];
        }
        return Observable.merge.apply(Observable, displayDataChanges).map(function () {
            return _this.getSortedData();
        });
    };
    /** Returns a sorted copy of the database data with Pagination. */
    TableDataSource.prototype.getSortedData = function () {
        var _this = this;
        var filterData;
        filterData = this.subject.getValue();
        if (this._sort) {
            if (!this._sort.active || this._sort.direction == '') {
                return this.setPagination(filterData);
            }
            return this.setPagination(filterData.sort(function (a, b) {
                var propertyA = '';
                var propertyB = '';
                _a = [a[_this._sort.active] ? a[_this._sort.active].toString().toLowerCase().trim() : '',
                    b[_this._sort.active] ? b[_this._sort.active].toString().toLowerCase().trim() : ''], propertyA = _a[0], propertyB = _a[1];
                var valueA = isNaN(+propertyA) ? propertyA : +propertyA;
                var valueB = isNaN(+propertyB) ? propertyB : +propertyB;
                return (valueA < valueB ? -1 : 1) * (_this._sort.direction == 'asc' ? 1 : -1);
                var _a;
            }));
        }
        else {
            return this.setPagination(filterData);
        }
    };
    /*
     * In this method we do pagination for grid.
     * Based on PageIndex and pageSize we filter records from all data and set it into filter data array
     * If there are no records in pagaination then hit request to get more records
     * After pagination, sort data and return finalData.
    */
    TableDataSource.prototype.setPagination = function (data) {
        var filterData = [];
        if (this._paginator) {
            var startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            // Filter record based on startIndex and page Size
            if (data && data.length > 0) {
                for (var i = startIndex; i < this._paginator.pageSize + startIndex; i++) {
                    if (data[i]) {
                        filterData.push(data[i]);
                    }
                }
            }
        }
        else {
            filterData = data;
        }
        return filterData;
    };
    TableDataSource.prototype.disconnect = function () {
    };
    /*for dynamic page updation
     url - url of the api to call
     event - page event
     me - this scope of the component
     urlSearchParams - extra seach parameter when needed(optional)*/
    TableDataSource.prototype.onPaginateChange = function (url, event, me, urlSearchParams) {
        var _this = this;
        try {
            var totalIndex = me.dataSubject.getValue().length / event.pageSize;
            totalIndex = (Math.ceil(totalIndex));
            if (event.pageIndex == totalIndex - 1) {
                var urlParams = this.curPage + "/?pageSize=100";
                if (urlSearchParams) {
                    urlParams = this.curPage + urlSearchParams;
                }
                return this._httpClient.get(url, urlParams)
                    .subscribe(function (response) {
                    if (response.response.results.length > 0) {
                        var existData = me.dataSubject.getValue(); // get exist data
                        var data = response.response.results;
                        // If data exist then concat new records in exists data collection.
                        var result = (existData.length != 0) ? existData.concat(data) : data;
                        me.dataSubject.next(result);
                        me.paginationInfo = response.response.paginationInfo; // update paginaton info
                        _this.curPage++;
                    }
                });
            }
        }
        catch (e) {
            console.log("Pagination error", e);
        }
    };
    return TableDataSource;
}(DataSource));
export { TableDataSource };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/md-table.ts.pre-build-optimizer.js